export default "__VITE_ASSET__wpp78imX__"